import React from "react";
import Dialog from "@material-ui/core/Dialog";
import { DialogTitle } from "../components/DialogTitle";
import { DialogContentWithCards } from "../components/DialogContent";
import { capitalize, timeStampToLongString } from "../utils/stringUtils";
import SimpleTable from "../components/SimpleTable";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import ListTable from "../components/ListTable";
import { AppCells } from "../components/AppCells";
import { Card } from "../components/Card";
import { PaperCard } from "../components/PaperCard";
import { TextInput } from "../components/TextInput";
import { SelectInput } from "../components/SelectInput";
import { ramToString, installedAppsToRows } from "../utils/deviceDialogUtils";
import LocationMap from "../components/LocationMap";

export const EditDeviceDialog = ({
  onClose,
  saveAvaliable,
  onSave,
  name,
  nameNotUnique,
  onNameChange,
  deviceGroupKey,
  onDeviceGroupChange,
  notes,
  onNotesChange,
  device: {
    name: deviceName,
    serial,
    vrType,
    osVersion,
    model,
    manufacturer,
    mac,
    availableStorage,
    ram,
    batteryLevel,
    lastUpdated,
    location
  },
  approvedApps,
  installedApps,
  deviceGroups
}) => (
    <Dialog maxWidth="lg" scroll="body" onClose={onClose} open spacing={0}>
      <DialogTitle
        onCancel={onClose}
        onSave={onSave}
        saveAvaliable={saveAvaliable}
        darkBg
      >
        Device: {deviceName}
      </DialogTitle>
      <DialogContentWithCards>
        <Typography variant="caption">* Required Inputs</Typography>
        <br />
        <br />
        <Grid container spacing={3}>
          <Grid item xs={6}>
            <Card>
              <Typography variant="h6">Managed Details</Typography>
              <TextInput
                label={nameNotUnique ? "Must be unique" : "Name"}
                value={name}
                onChange={onNameChange}
                required
                error={nameNotUnique}
              />
              <SelectInput
                label="Device Group *"
                value={deviceGroupKey}
                onChange={onDeviceGroupChange}
                options={deviceGroups.map(s => ({ value: s.key, label: s.name }))}
              />
              <TextInput
                label="Notes"
                value={notes}
                onChange={onNotesChange}
                multiline
                rowsMax="3"
              />
            </Card>
          </Grid>
          <Grid item xs={6}>
            <Card>
              <Typography variant="h6">Hardware Details</Typography>
              <ListTable
                rows={[
                  ["VR Type", vrType ? capitalize(vrType) : ""],
                  ["Model", model],
                  ["Manufacturer", manufacturer],
                  ["OS Version", osVersion],
                  ["Serial", serial],
                  ["MAC", mac]
                ]}
              />
            </Card>
          </Grid>
          <Grid item xs={6}>
            <Card>
              <Typography variant="h6">Device Status</Typography>
              <ListTable
                rows={[
                  ["Last Used", timeStampToLongString(lastUpdated)],
                  ["Battery Level", batteryLevel ? batteryLevel + "%" : ""],
                  ["Available Storage", availableStorage],
                  ["RAM Usage", ramToString(ram)]
                ]}
              />
            </Card>
          </Grid>
          <Grid item xs={6}>
            <Card>
              <Typography variant="h6">Last Location</Typography>
              {(location && location.geo) && <LocationMap location={location} />}
              {(!location || !location.geo) && (
                <Typography variant="body1">Location Not Available</Typography>
              )}
            </Card>
          </Grid>
          <Grid item xs={12}>
            <PaperCard>
              <Typography variant="h6">Approved Apps</Typography>
              <AppCells apps={approvedApps} installedApps={installedApps} />
            </PaperCard>
          </Grid>
          <Grid item xs={12}>
            <PaperCard>
              <Typography variant="h6">Installed Apps</Typography>
              <SimpleTable
                headers={["Name", "Package Name", "Version", "Last Updated"]}
                rows={installedAppsToRows(installedApps)}
              />
            </PaperCard>
          </Grid>
        </Grid>
        <br />
      </DialogContentWithCards>
    </Dialog>
  );
